<div class="menu-viewer" *ngIf="!loading">
  <!-- Header del Restaurante -->
  <div class="restaurant-header" *ngIf="restaurant">
    <div class="restaurant-info">
      <h1 class="restaurant-name">{{ restaurant.name }}</h1>
      <p class="restaurant-address">📍 {{ restaurant.address }}</p>
      <div class="restaurant-features">
        <span *ngIf="tableId" class="table-info">🪑 Mesa {{ tableId }}</span>
        <span *ngIf="viewMode === 'order-enabled'" class="order-enabled">✅ Pedidos habilitados</span>
        <span *ngIf="viewMode === 'view-only'" class="view-only">👁️ Solo visualización</span>
      </div>
    </div>
    <div class="restaurant-actions">
      <button class="share-btn" (click)="shareMenu()">🔗 Compartir</button>
      <button 
        *ngIf="canOrderToBar() || canOrderToTable()" 
        class="cart-btn" 
        (click)="toggleCart()"
        [class.has-items]="getCartItemCount() > 0"
      >
        🛒 Carrito
        <span *ngIf="getCartItemCount() > 0" class="cart-count">{{ getCartItemCount() }}</span>
      </button>
    </div>
  </div>

  <!-- Búsqueda y Filtros -->
  <div class="search-filters">
    <form [formGroup]="searchForm" class="search-form">
      <div class="search-input">
        <input 
          type="text" 
          formControlName="search" 
          placeholder="Buscar platos..."
          class="search-field"
        >
        <span class="search-icon">🔍</span>
      </div>
    </form>

    <form [formGroup]="filterForm" class="filter-form">
      <select formControlName="category" class="filter-select">
        <option value="all">Todas las categorías</option>
        <option *ngFor="let category of categories" [value]="category">
          {{ category }}
        </option>
      </select>
      
      <div class="price-filter">
        <label>Precio máximo: {{ filterForm.get('maxPrice')?.value }}€</label>
        <input 
          type="range" 
          formControlName="maxPrice" 
          min="0" 
          max="100" 
          step="5"
          class="price-range"
        >
      </div>
    </form>
  </div>

  <!-- Categorías del Menú -->
  <div class="menu-categories" *ngIf="categories.length > 1">
    <button 
      *ngFor="let category of categories"
      class="category-btn"
      [class.active]="selectedCategory === category"
      (click)="selectCategory(category)"
    >
      {{ category }}
    </button>
  </div>

  <!-- Lista del Menú -->
  <div class="menu-content">
    <div class="menu-items">
      <div 
        *ngFor="let item of currentCategoryItems" 
        class="menu-item"
        [class.unavailable]="!item.available"
        (click)="showItemDetail(item)"
      >
        <div class="item-image">
          <img [src]="getItemImageUrl(item)" [alt]="item.name" loading="lazy">
          <div *ngIf="!item.available" class="unavailable-overlay">
            <span>No disponible</span>
          </div>
        </div>
        
        <div class="item-info">
          <div class="item-header">
            <h3 class="item-name">{{ item.name }}</h3>
            <span class="item-price">{{ formatPrice(item.price) }}</span>
          </div>
          
          <p class="item-description">{{ item.description }}</p>
          
          <div class="item-details">
            <span class="prep-time">⏱️ {{ formatPreparationTime(item.preparationTime) }}</span>
            <div class="allergens" *ngIf="item.allergens.length > 0">
              <span class="allergen-label">⚠️ Alérgenos:</span>
              <span class="allergen-list">{{ item.allergens.join(', ') }}</span>
            </div>
          </div>
          
          <div class="item-tags" *ngIf="item.tags && item.tags.length > 0">
            <span *ngFor="let tag of item.tags" class="tag">{{ tag }}</span>
          </div>
        </div>

        <div class="item-actions" *ngIf="viewMode === 'order-enabled' && item.available">
          <button 
            class="quick-add-btn"
            (click)="addToCart(item, 1); $event.stopPropagation()"
          >
            + Añadir
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal de Detalle del Producto -->
  <div class="modal-overlay" *ngIf="showItemDetails" (click)="closeItemDetail()">
    <div class="item-detail-modal" (click)="$event.stopPropagation()" *ngIf="selectedItem">
      <div class="modal-header">
        <h2>{{ selectedItem.name }}</h2>
        <button class="close-btn" (click)="closeItemDetail()">✕</button>
      </div>
      
      <div class="modal-content">
        <div class="item-detail-image">
          <img [src]="getItemImageUrl(selectedItem)" [alt]="selectedItem.name">
        </div>
        
        <div class="item-detail-info">
          <p class="detail-description">{{ selectedItem.description }}</p>
          
          <div class="detail-specs">
            <div class="spec">
              <span class="spec-label">💰 Precio:</span>
              <span class="spec-value">{{ formatPrice(selectedItem.price) }}</span>
            </div>
            <div class="spec">
              <span class="spec-label">⏱️ Tiempo:</span>
              <span class="spec-value">{{ formatPreparationTime(selectedItem.preparationTime) }}</span>
            </div>
            <div class="spec" *ngIf="selectedItem.allergens.length > 0">
              <span class="spec-label">⚠️ Alérgenos:</span>
              <span class="spec-value">{{ selectedItem.allergens.join(', ') }}</span>
            </div>
          </div>
          
          <div class="order-controls" *ngIf="viewMode === 'order-enabled' && selectedItem.available">
            <div class="quantity-control">
              <label>Cantidad:</label>
              <div class="quantity-buttons">
                <button (click)="itemQuantity = itemQuantity > 1 ? itemQuantity - 1 : 1">-</button>
                <span class="quantity">{{ itemQuantity }}</span>
                <button (click)="itemQuantity = itemQuantity + 1">+</button>
              </div>
            </div>
            
            <div class="notes-control">
              <label>Notas especiales:</label>
              <textarea 
                [(ngModel)]="itemNotes"
                placeholder="Ej: Sin cebolla, poco hecho..."
                rows="3"
              ></textarea>
            </div>
            
            <div class="modal-actions">
              <span class="total-price">
                Total: {{ formatPrice(selectedItem.price * itemQuantity) }}
              </span>
              <button 
                class="add-to-cart-btn"
                (click)="addToCart(selectedItem, itemQuantity, itemNotes)"
              >
                Añadir al carrito
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Panel del Carrito -->
  <div class="cart-panel" [class.show]="showCart">
    <div class="cart-header">
      <h3>🛒 Tu pedido</h3>
      <button class="close-cart" (click)="toggleCart()">✕</button>
    </div>
    
    <div class="cart-content">
      <div *ngIf="cart.length === 0" class="empty-cart">
        <p>Tu carrito está vacío</p>
        <p>Añade productos del menú para comenzar tu pedido</p>
      </div>
      
      <div *ngIf="cart.length > 0" class="cart-items">
        <div *ngFor="let item of cart; let i = index" class="cart-item">
          <div class="cart-item-info">
            <h4>{{ item.menuItem.name }}</h4>
            <p *ngIf="item.notes" class="item-notes">📝 {{ item.notes }}</p>
            <div class="item-price">{{ formatPrice(item.menuItem.price) }} × {{ item.quantity }}</div>
          </div>
          
          <div class="cart-item-controls">
            <div class="quantity-controls">
              <button (click)="updateCartItemQuantity(i, item.quantity - 1)">-</button>
              <span>{{ item.quantity }}</span>
              <button (click)="updateCartItemQuantity(i, item.quantity + 1)">+</button>
            </div>
            <div class="item-subtotal">{{ formatPrice(item.subtotal) }}</div>
            <button class="remove-item" (click)="removeFromCart(i)">🗑️</button>
          </div>
        </div>
      </div>
    </div>
    
    <div *ngIf="cart.length > 0" class="cart-footer">
      <div class="cart-total">
        <strong>Total: {{ formatPrice(getCartTotal()) }}</strong>
      </div>
      
      <div class="order-buttons">
        <button 
          *ngIf="canOrderToBar()"
          class="order-btn bar-order"
          (click)="proceedToOrder('bar')"
        >
          🍺 Pedir en barra
        </button>
        
        <button 
          *ngIf="canOrderToTable()"
          class="order-btn table-order"
          (click)="proceedToOrder('table')"
        >
          🪑 Pedir a mesa
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Estado de carga -->
<div *ngIf="loading" class="loading-state">
  <div class="spinner"></div>
  <p>Cargando menú...</p>
</div>

<!-- Estado de error -->
<div *ngIf="error" class="error-state">
  <div class="error-icon">❌</div>
  <h3>Error al cargar el menú</h3>
  <p>{{ error }}</p>
  <button (click)="loadMenu()" class="retry-btn">Reintentar</button>
</div>